<template>
    <v-main class="pa-2" fluid>
        <h1>Roles</h1>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new Role</v-btn>
                </template>
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-form ref="form" v-model="valid" class="row">
                                    <v-col cols="12" md="12">
                                        <v-text-field label="title" v-model="editedItem.title" :rules="nameRules" required></v-text-field>

                                        <v-select
          v-model="editedItem.rules"
          :items="ability"
          label="Abilities"
          multiple
          chips
          hint="Select the Abilities you want for this role"
          persistent-hint
        ></v-select>
                                    </v-col>
                                    
                                </v-form>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="roles"
            :items-per-page="10"
            class="elevation-1">
                <template v-slot:item.actions="{ item }">

                <v-btn v-if="item.name !== 'admin'" icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <!-- <v-btn icon small color="red" @click="deleteRole(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn> -->

                </template>

                <!-- <template v-slot:item.status="{ item }">
                    <v-switch :success="item.status == 1 ? true : false" @change="updateStatus(item)"
                                  v-model="item.status"
                                  inset
                                  :label="getUserSwitchLabel(item.status)"
                            ></v-switch>
                </template> -->
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'title', },
                     { text: 'Abilities', align: 'start', sortable: true, value: 'rules' },
                    { text: '', align: 'start', sortable: true, value: 'actions' },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedItem: {
                    name : '',
                    status : 1

                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
            }
        },

        mounted () {
            if( this.roles.length == 0 )
            this.$store.dispatch('fetchRoles')
        },


        computed: {
            ...mapState(['roles']),
            ...mapGetters(['ability']),

            formTitle () {

                return this.editedIndex === -1 ? 'New Role' : 'Edit Role'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.roles.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/roles/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.roles[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/roles', this.editedItem)
                    .then( response => {

                        this.roles.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              updateStatus(item) {

                this.editedIndex = this.roles.indexOf(item)
                this.editedItem = Object.assign({}, item)

                axios.put('/api/roles/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                            
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

            },


              deleteRole(id) {

                confirm('Are you sure you want to delete this Role? This action can not be undone') && 

                axios.delete('/api/roles/' + id)
                        .then( response => {

                            const index = this.roles.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.roles.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              }
          }
    }
</script>